import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { CurrencyFormats } from '@sm360/widget-commons-vehicle';

import 'build-and-quote/components/OptionsResolutions/components/ResolutionBlock/ResolutionBlock.scss';

const ResolutionBlock = ({
    body,
    id,
    paymentFrequencyLabel,
    pricingDifferenceTotal,
    selected,
    selectOptionsResolution,
    showPayments,
}) => {
    const paymentDiff = showPayments && (
        <span>
            <span className="sr-text is-bold priceChange">
                {LocaleService.l(pricingDifferenceTotal.payment, CurrencyFormats.CURRENCY_2)}
            </span>
            {paymentFrequencyLabel}
        </span>
    );

    const wrapperClass = ['optionsResolutions__resolutionBlock'];
    wrapperClass.push(selected && 'selected');

    return (
        <div className={wrapperClass.join(' ')}>
            {body}
            <div className="optionsResolutions__resolutionBlock--footer">
                <div className="sr-text is-bold">{LocaleService.t('OPTIONS_RESOLUTIONS.TOTAL_CHANGE')}</div>
                <div>
                    {paymentDiff} ({LocaleService.l(pricingDifferenceTotal.retail, CurrencyFormats.CURRENCY_0)})
                    <div className="is-light">{LocaleService.t('OPTIONS_RESOLUTIONS.TAXESNOTINCLUDED')}</div>
                </div>
                <div>
                    <button onClick={() => selectOptionsResolution(id)} className="option-choose-cta">
                        <icon className="icon-Crochet" />
                        {selected ? LocaleService.t('SELECTED') : LocaleService.t('CHOOSE')}
                    </button>
                </div>
            </div>
        </div>
    );
};

ResolutionBlock.propTypes = {
    body: PropTypes.node.isRequired,
    id: PropTypes.string.isRequired,
    paymentFrequencyLabel: PropTypes.string.isRequired,
    pricingDifferenceTotal: PropTypes.shape({
        retail: PropTypes.number.isRequired,
        taxes: PropTypes.number.isRequired,
        payment: PropTypes.number.isRequired,
        paymentTaxes: PropTypes.number.isRequired,
    }).isRequired,
    selected: PropTypes.bool.isRequired,
    selectOptionsResolution: PropTypes.func.isRequired,
    showPayments: PropTypes.bool.isRequired,
};

ResolutionBlock.displayName = 'ResolutionBlock';

export default ResolutionBlock;
